
import { t } from '@/i18n'
import router from './router'
import store from './store'
import NProgress from 'nprogress' // 进度条
import 'nprogress/nprogress.css' // 进度条 style
import { Message } from 'element-ui'
import { canAccessRouteMeta } from '@/utils/authorization'
import { findAccessibleTerminalEntry } from '@/utils/workspace'
import { recordTerminalRoute } from '@/utils/terminalRouteHistory'

NProgress.configure({ showSpinner: false }) // 进度条 Configuration

const LOGIN_PATH = '/login'
const NOT_FOUND_PATH = '/404'

function canAccess (meta = {}, params = {}) {
  return canAccessRouteMeta(store.state.user, meta, params)
}

function getAuthenticatedEntry () {
  return findAccessibleTerminalEntry(
    router,
    meta => canAccess(meta),
    `/admin/edit/${store.state.user.id}`
  )
}

function isInternalPath (path) {
  return typeof path === 'string' &&
    path.startsWith('/') &&
    !path.startsWith('//') &&
    path.split('?')[0] !== LOGIN_PATH
}

/**
 * @description: 路由前置守卫
 */
router.beforeEach((to, from, next) => {
  NProgress.start()

  // 初始化用户信息
  store.commit('user/initUser')
  const token = store.state.user.token
  // 判断 token 是否存在
  if (!token) {
    if (to.path === LOGIN_PATH) return next()
    return next({
      path: LOGIN_PATH,
      replace: true,
      query: { redirect: to.fullPath }
    })
  }

  if (to.path === LOGIN_PATH) {
    const redirect = to.query.redirect
    return next(isInternalPath(redirect) ? redirect : getAuthenticatedEntry())
  }

  if (to.path === NOT_FOUND_PATH) {
    return next()
  }

  // 校验权限
  if (canAccess(to.meta, to.params)) {
    return next()
  }

  const isInitialLoginNavigation = from && from.path === LOGIN_PATH
  if (isInitialLoginNavigation || !from || !from.matched || from.matched.length === 0) {
    const fallback = getAuthenticatedEntry()
    if (fallback && fallback !== to.path) return next({ path: fallback, replace: true })
  }

  Message.warning(t('当前角色没有此页面权限'))
  if (from && from.matched && from.matched.length > 0) {
    NProgress.done()
    return next(false)
  } else {
    return next(getAuthenticatedEntry())
  }
})

/**
 * @description: 路由完成 结束进度条
 */
router.afterEach((to) => {
  recordTerminalRoute(to)
  // 只有导航真正完成后才更新标题，避免无权路由被取消或重定向时留下错误标题。
  document.title = t(getPageTitle(to.meta.title))
  NProgress.done() // 结束进度条
})

router.onError(() => {
  NProgress.done()
})

/**
 * @description: meta title 和全局 title 组合
 * @return: title
 * @param {*} pageTitle 路由 meta.title
 */
function getPageTitle (pageTitle) {
  return pageTitle ? `${t(pageTitle)} - ${t(store.state.settings.title)}` : t(store.state.settings.title)
}
